import { render, staticRenderFns } from "./SFLoader.vue?vue&type=template&id=fc819a86&scoped=true&lang=pug&"
import script from "./SFLoader.vue?vue&type=script&lang=js&"
export * from "./SFLoader.vue?vue&type=script&lang=js&"
import style0 from "./SFLoader.vue?vue&type=style&index=0&id=fc819a86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc819a86",
  null
  
)

export default component.exports